import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterOutlined } from '@ant-design/icons';
import { InitiativeScopeItem } from './ScopeItem';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { getSonarObjectTypeAndSourceLabel, isPardotType, isSonarObjectTypeInitiativeFilterAllowed } from '@sonar-software/sonar-ts-lib';
export const initiativeScopeTableNameColumn = {
    defaultSortOrder: 'ascend',
    key: 'name',
    onCell: () => ({ colSpan: 2 }),
    render: (value, item) => React.createElement(InitiativeScopeItem, { initiativeId: item.initiativeId, itemId: item.id, sonarObjectId: item.sonarObjectId }),
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
    title: COPY_SPECIFIC.NAME
};
const sonarObjectsFilterOptions = Object.values(SonarObjectType)
    .filter(isSonarObjectTypeInitiativeFilterAllowed)
    .filter(getSonarObjectTypeAndSourceLabel)
    .map((type) => ({
    text: getSonarObjectTypeAndSourceLabel(type),
    value: type
}));
export const initiativeScopeTableTypeColumn = {
    filterIcon: React.createElement(FilterOutlined, null),
    filters: sonarObjectsFilterOptions,
    key: 'type',
    onCell: () => ({ colSpan: 0 }),
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
    title: COPY_SPECIFIC.TYPE
};
export function getInitiativeScopeTableColumns(isPardotEnabled) {
    var _a;
    if (!isPardotEnabled) {
        return [
            initiativeScopeTableNameColumn,
            Object.assign(Object.assign({}, initiativeScopeTableTypeColumn), { filters: (_a = initiativeScopeTableTypeColumn.filters) === null || _a === void 0 ? void 0 : _a.filter((entry) => !isPardotType(entry.value)) })
        ];
    }
    return [initiativeScopeTableNameColumn, initiativeScopeTableTypeColumn];
}
